import React from "react";
import { createRoot } from "react-dom/client";

import { AppProviders } from "@src/bootstrap/createAppProviders";
import { initMixpanel } from "@src/bootstrap/initMixpanel";
import { initSentry } from "@src/bootstrap/initSentry";
import { registerVitePreloadRecovery } from "@src/bootstrap/registerVitePreloadRecovery";
import { setupAgGrid } from "@src/bootstrap/setupAgGrid";
import { ShareApp } from "@src/ShareApp";

import "./App.css";

// Minimal initialization for shared views
// Includes: QueryClient, Redux (5 slices), Theme, Sentry (errors only), Mixpanel (page views only), AG-Grid (for analytics tables)
// Excludes: Chameleon and Apollo

// Initialize AG-Grid
const isProd = window.location.hostname === "share.intelligems.io";
setupAgGrid({
  licenseKey:
    "Using_this_{AG_Grid}_Enterprise_key_{AG-076655}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Intelligems}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{intelligems.io}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{intelligems.io}_need_to_be_licensed___{intelligems.io}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{6_February_2026}____[v3]_[01]_MTc3MDMzNjAwMDAwMA==4a993a3369ba60e3c8f6ee1924f099f7",
  includeValidation: isProd,
});

// Initialize Mixpanel for basic tracking
initMixpanel({
  prodHost: "share.intelligems.io",
  devToken: "eacc2d71bd5d818fed4768c641aeb284",
  prodToken: "aaf6d392bdbfdc48717cb30ff41f15b7",
});

// Initialize Sentry for error tracking (minimal config)
initSentry({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  environment: import.meta.env.VITE_STAGE,
  enabled: import.meta.env.VITE_RUNNING_LOCAL !== "true",
  tracesSampleRate: 0, // No performance monitoring for share bundle
});

registerVitePreloadRecovery();

function main() {
  const rootApp = (
    <AppProviders>
      <ShareApp />
    </AppProviders>
  );

  const container = document.getElementById("root");

  if (!container) {
    throw new Error("Could not find container #root");
  }

  const root = createRoot(container);
  root.render(rootApp);
}

main();
